import { Component, Show } from "solid-js";
import MetadataForm from "./MetadataForm";

type Props = {
  open: boolean;
  onClose: () => void;
  startTime: Date | null;
  endTime: Date | null;
  autoLocation: string;
  caseLocation: string;
  setCaseLocation: (v: string) => void;
  contactType: string;
  setContactType: (v: string) => void;
  notes: string;
  setNotes: (v: string) => void;
};

const CaseDetailsModal: Component<Props> = (p) => (
  <Show when={p.open}>
    <div class="fixed inset-0 bg-black/40 backdrop-blur-sm z-40" />
    <div class="fixed inset-0 z-50 grid place-items-center px-4">
      <div class="bg-white rounded-lg shadow-xl w-full max-w-md p-6 space-y-4">
        <MetadataForm
          startTime={p.startTime}
          endTime={p.endTime}
          autoLocation={p.autoLocation}
          caseLocation={p.caseLocation}
          setCaseLocation={p.setCaseLocation}
          contactType={p.contactType}
          setContactType={p.setContactType}
          notes={p.notes}
          setNotes={p.setNotes}
        />

        {/* buttons */}
        <div class="flex justify-end gap-3 pt-2">
          <button
            class="text-sm px-3 py-1 rounded border border-gray-300"
            onClick={p.onClose}
          >
            Cancel
          </button>

          <button
            class="bg-emerald-600 hover:bg-emerald-700 text-white text-sm px-4 py-1 rounded"
            onClick={p.onClose}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </Show>
);

export default CaseDetailsModal;
